import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Tooltip } from "@mui/material";

export const MessageSearchBar = ({ searchOpen, searchText, inputRef, onOpen, onClose, onChange, onClear }) => {
  if (!searchOpen) {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-end", px: 1, py: 0.5, flexShrink: 0 }}>
        <Tooltip title="Search messages">
          <IconButton size="small" aria-label="Search messages" onClick={onOpen} sx={{ color: "text.secondary" }}>
            <SearchIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.5,
        flexShrink: 0,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <IconButton size="small" aria-label="Close search" onClick={onClose} sx={{ color: "text.secondary" }}>
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>

      <SearchIcon sx={{ fontSize: 18, color: "text.disabled", flexShrink: 0 }} />

      <Box
        component="input"
        ref={inputRef}
        value={searchText}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Search messages..."
        sx={{
          flex: 1,
          minWidth: 0,
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: 13.5,
          color: "text.primary",
          "&::placeholder": { color: "text.disabled" },
        }}
      />

      {searchText && (
        <IconButton size="small" aria-label="Clear search" onClick={onClear} sx={{ p: 0.25 }}>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
    </Box>
  );
};
